import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import usePage from 'hooks/common/usePage';

window.NB_NAVIGATION_LOG = +(window.localStorage.getItem('NB_NAVIGATION_LOG') || 0);
export default function useNavigation(id) {
  const [pages, setPages] = Recoil.useRecoilState(AppStore.navigation.pages(id));
  if(window.NB_NAVIGATION_LOG) console.log(id, pages);
  return usePage({ pages, setPages });
}
